import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import theme from 'theme';

const TableToolbarCC = ({ numSelected, autoShow = false, total, children, noResponsive = false }) => {
    const {t} = useTranslation()
    return (Boolean(numSelected) || autoShow) ? (
        <Box sx={{ display: 'flex', flexDirection: !noResponsive ? {xs: 'column', sm: 'row'} : 'row',alignItems: 'center', justifyContent: 'space-between', padding: `${theme.spacing(2)} 0` }}>
            <Typography sx={{ fontSize: '0.875em' }}>
                {Boolean(numSelected) && t('tablev1.selectedNum', {num: numSelected, total: total})}
            </Typography>
            { children }
        </Box>
    ) : <></>;
}

export default TableToolbarCC